import React from 'react';
import { Link } from 'react-router-dom';
import { MENU_ICON } from '../../utils/consts';
import MasterDesignLogoLight from '../../assets/images/master-design-logo-light.png';
import MasterDesignLogoDark from '../../assets/images/master-design-logo-dark.png';
import WebCheckLogo from '../../assets/images/web-check-logo.png';
import { Button } from '../../components';
import { useTheme } from '../../hooks/theme-hook';

const Header = ({ has_sidebar = true }) => {
	const { isDarkMode } = useTheme();

	return (
		<header className='navbar background-secondary border-tertiary py-1 '>
			<div className='container-fluid d-flex justify-content-between mx-md-5'>
				<div>
					{has_sidebar && (
						<Button
							classes='d-lg-none mx-sm-3 ms-md-0 p-0 color-header'
							data-bs-toggle='offcanvas'
							data-bs-target='#offcanvasResponsive'
							icon={`${MENU_ICON}`}
						/>
					)}
					<Link
						to={'https://www.masterdesign.at/'}
						target='_blank'
						className='navbar-brand'>
						<img
							src={isDarkMode ? MasterDesignLogoDark : MasterDesignLogoLight}
							width={130}
							alt='master design Logo'
						/>
					</Link>
				</div>

				<div className='navbar-brand'>
					<img src={WebCheckLogo} width={155} alt='web check Logo' />
				</div>
			</div>
		</header>
	);
};

export default Header;
